/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import WaitingGPTResponseMessage from './WaitingGPTResponseMessage';
import { useEffect, useRef, useState } from 'react';
import { Storage } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import AIResponse from './AIResponse';

ListMessageChatAI.propTypes = {
    listMessageContent: PropTypes.any,
    chatThreadId: PropTypes.any,
    setListMessageContent: PropTypes.any,
    isEnableBtnSend: PropTypes.any,
    setIsEnableBtnSend: PropTypes.any,
    panelId: PropTypes.any,
    corporationDetail: PropTypes.any,
    currentUserDetail: PropTypes.any,
    setUserSelectedPrompt: PropTypes.any,
    idOfResponseMessage: PropTypes.any,
    setIdOfResponseMessage: PropTypes.any,
    projectInfo: PropTypes.any,
    projectInuseDetail: PropTypes.any,
    usingAI: PropTypes.any,
    isAiAutoLog: PropTypes.any,
    aiAutoPromptTitle: PropTypes.any
};

export default function ListMessageChatAI({
    listMessageContent,
    chatThreadId,
    setListMessageContent,
    isEnableBtnSend,
    setIsEnableBtnSend,
    panelId,
    corporationDetail,
    currentUserDetail,
    setUserSelectedPrompt,
    idOfResponseMessage,
    setIdOfResponseMessage,
    projectInfo,
    projectInuseDetail,
    usingAI,
    isAiAutoLog = false,
    aiAutoPromptTitle
}) {
    const messagesEndRef = useRef(null);
    const [isDisplayJump, setIsDisplayJump] = useState(false);
    const [logUrl, setLogUrl] = useState('');
    const intervalUpdateLogURL = useRef();

    useEffect(() => {
       if (listMessageContent.length > 0) {
            jumpToBottom();
       }
    }, [listMessageContent]);

    const scrollToBottom = () => {
        setTimeout(() => {
            jumpToBottom();
        }, 1000);
    };

    const jumpToBottom = () => {
        let idDivContentList = `divChatContentList-${panelId}-${chatThreadId}`;
        const element = document.getElementById(idDivContentList);
        if (!element) {
            console.log('jumpToBottom element error: ', element)
            return;
        }

        element.scrollTop = element.scrollHeight;
        setIsDisplayJump(false);
    };

    const handleScrollListMessage = (e, chatThreadId) => {
        let element = e.target;
        if (element.offsetHeight + element.scrollTop >= element.scrollHeight - 100) {
            setIsDisplayJump(false);
        } else {
            setIsDisplayJump(true);
        }
    };

    const isShowButtonLog = () => {
        let userSetting = Utils.convertJSONDataToObject(currentUserDetail.userSetting);
        
        // filter message hidden
        let listContentMessageClone =  listMessageContent?.filter(message => !message.isHidden);

        const adminMode = userSetting?.adminMode;
        if(listContentMessageClone.length < 1) {            
            return false;
        }
        if (listContentMessageClone.length === 2 && listContentMessageClone[1]?.isLoadingMessage) {            
            return false;
        }

        if (
            listContentMessageClone.length > 1 &&
            new Date(listContentMessageClone[0].dateTime) < new Date('2024-03-03')
        ) {           
            return false;
        }

        if (corporationDetail?.rootFlag && adminMode === Constant.ADMIN_MODE.ON && Utils.isAdminUser(currentUserDetail)) {
            return true;
        }

        if (!Utils.isEmptyObject(projectInuseDetail)) {
            let projectSetting = Utils.convertJSONDataToObject(projectInuseDetail?.projectSetting);
            let chatAiSetting = projectSetting.chatAISetting;

            if (chatAiSetting?.isShowLogAiChat && !Utils.isB2CUser(currentUserDetail)) {
                return true;
            } 
        }
        return false;
    };

    useEffect(() => {
        let isMounted = true;
        const updateLogURL = async () => {
            if (isMounted) {
                const url = await Storage.get(`log-chat-ai/${chatThreadId}.json`, {expires: 7200});
                setLogUrl(url);
            }
        };

        updateLogURL();
        
        intervalUpdateLogURL.current = setInterval(() => {
            updateLogURL();
        }, 59 * 60 * 1000);
    
        return () => {
            isMounted = false;
            if (intervalUpdateLogURL.current) {
                clearInterval(intervalUpdateLogURL.current);
                intervalUpdateLogURL.current = null;
            }
        };
      }, [chatThreadId]);

    return (
        <>
            <div
                className="list-msg-content"
                id={`divChatContentList-${panelId}-${chatThreadId}`}
                onScroll={e => handleScrollListMessage(e, chatThreadId)}
            >
                {isAiAutoLog && aiAutoPromptTitle.length > 0 && (
                    <p className='ai-auto-prompt-title'>{`「${aiAutoPromptTitle}」から起動されました。`}</p>
                )}

                {listMessageContent?.map((message, index) => {
                    const filterContent = Utils.replaceUrls(
                        message.isFromMe ? Utils.escapeHtmlCharacters(message.content) : message.content,
                        false,
                        false,
                        '',
                        message?.isFromMe,
                        true
                    );

                    let messageClass = 'message-text';
                    if (message.isError) {
                        messageClass = 'message-error';
                    } else if (message.isWaring) {
                        messageClass = 'message-warning';
                    }


                    return (
                        <div
                            key={message.id || index}
                            className={`chat-item-message ${
                                message.isFromMe ? 'from-me' : 'from-them'
                            } ${message.isHidden ? 'hidden' : 'display'}`}
                        >
                            {!message.isError ? (
                                <div className="message-header">
                                    {!message.isFromMe && (
                                        <div className="avatar-ai">
                                            <img src="/assets/image/avatar-ai.svg" alt="avatar" />
                                        </div>
                                    )}
                                    <OverFlowTooltipWithTabsMui
                                        value={message.isFromMe ? message.user : 'AI'}
                                        className="chat-ai-name"
                                    />
                                    <div className="time-chat-ai">
                                        {message?.dateTime ? message?.dateTime : ''}
                                    </div>
                                </div>
                            ) : (
                                <div className="message-error-header"></div>
                            )}
                            {message.isFromMe ? (
                                <div
                                    className="message-text"
                                    style={{ backgroundColor: isAiAutoLog ? '#FFEDB3' : '' }}
                                    dangerouslySetInnerHTML={{ __html: filterContent }}
                                />
                            ) : (
                                <div
                                    className={messageClass}
                                >
                                    {message.isLoadingMessage ? (
                                        <WaitingGPTResponseMessage
                                            setListMessageContent={setListMessageContent}
                                            setIsEnableBtnSend={setIsEnableBtnSend}
                                            idOfResponseMessage={idOfResponseMessage}
                                            scrollToBottom={scrollToBottom}
                                            usingAI={usingAI}
                                        />
                                    ) : (
                                        // <span dangerouslySetInnerHTML={{ __html: filterContent}} />
                                        <AIResponse data={message} isPublicSite={false}/>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
                {listMessageContent.length > 0 && (<div ref={messagesEndRef} ></div>)} 
            </div>
            <button
                className={`btn-reset-default ${isDisplayJump ? 'jumpBottom' : 'jumpBottom jumpBottom--dnone'}`}
                onClick={jumpToBottom}
            >
                <div className="jumpBottom-wrap">
                    <div className="jumpBottom-box">
                        <svg width="16px" height="16px" viewBox="0 0 24 24" className="">
                            <path fill="none" d="M0 0h24v24H0V0z"></path>
                            <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path>
                        </svg>
                        Jump to Bottom
                    </div>
                </div>
            </button>
            {isShowButtonLog() && logUrl && (
                <div className="button-open-log-chat">
                    <a href={logUrl}  className='text-link' target='_blank' rel="noreferrer">詳細</a>
                </div>
            )}
            
        </>
    );
}
